import { Theme, css } from '@emotion/react';

export const selectRoot = ({ colors, spacing }: Theme) => css`
  .MuiSelect-select {
    padding: 12.5px ${spacing(4)}px 12.5px 14px;
    width: auto;
    &:focus {
      background-color: transparent;
    }
  }
  .MuiSelect-outlined {
    padding-right: ${spacing(4)}px;
  }
  .MuiSelect-disabled {
    background-color: ${colors.backgroundLightest};
  }
`;
